/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';

interface LogoProps {
  title?: string;
}

/**
 * This is the Logo component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 */
function Logo({ title = 'Det Norske Teatret' }: LogoProps) {
  return (
    <span className="svg svg-logo">
      <span>
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 110 59"
          enableBackground="new 0 0 110 59"
          xmlSpace="preserve"
          role="img"
        >
          <title>{title}</title>
          <g
            id="Det-Norske-Teatret-Logo"
            transform="translate(-1.000000, -1.000000)"
          >
            <g id="Nylogo" transform="translate(1.512000, 1.440000)">
              <path
                id="Combined-Shape"
                d="M29.4,42v3.1h-4.3v13.5h-3.9V45.1H17V42H29.4z M41.3,42v3.1h-6.9v3.4h6.5v3.1h-6.5v3.8h7.1v3.1H30.5V42H41.3z M52.5,42l6.2,16.6h-4.2l-1.2-3.3h-5.9l-1.2,3.3h-4L48.5,42H52.5z M69,42v3.1h-4.3v13.5h-3.9V45.1h-4.3V42H69z M76.6,42c1.8,0,3.3,0.4,4.4,1.2c1.1,0.8,1.8,2.1,1.8,3.8c0,3.1-2,4.4-3.2,4.8l0,0l4.2,6.8h-4.5l-3.5-6.3h-1.2v6.3h-3.9V42H76.6z M95.7,42v3.1h-6.9v3.4h6.5v3.1h-6.5v3.8h7.1v3.1H85V42H95.7z M109.4,42v3.1h-4.3v13.5h-3.9V45.1H97V42H109.4z M50.7,46.2l-2.1,6h4.1L50.7,46.2z M76.3,45h-1.5v4.2h1.5c0.9,0,1.5-0.1,2-0.5c0.5-0.4,0.8-0.8,0.8-1.7c0-0.8-0.3-1.3-0.8-1.7C77.8,45.1,77.2,45,76.3,45L76.3,45z M57,20.8c1.9,0,4.1,0.9,5.3,2l0,0l-1.7,2.7c-1-1-2.4-1.7-3.7-1.7s-2.2,0.5-2.2,1.5s0.9,1.4,1.7,1.7c0.7,0.3,1.9,0.7,2.5,0.9c0.5,0.2,1.6,0.6,2.3,1.3c0.7,0.7,1.3,1.7,1.3,3.2c0,1.6-0.7,3-1.9,4c-1.2,0.9-2.7,1.4-4.5,1.4c-2.4,0-4.5-1.2-5.9-2.5l0,0l1.9-2.8c1.2,1.2,3,2.1,4.3,2.1c1.2,0,2.2-0.6,2.2-1.7c0-1.1-1.2-1.6-1.9-1.8s-2-0.7-2.5-0.9c-0.4-0.2-1.2-0.5-2-1.2c-0.7-0.7-1.3-1.6-1.3-3.2c0-1.6,0.8-2.8,1.7-3.6C53.6,21.3,55.1,20.8,57,20.8z M25.9,20.7c4.9,0,8.8,3.2,8.8,8.6c0,5.4-3.9,8.5-8.8,8.5s-8.8-3.2-8.8-8.5C17.2,24,21,20.7,25.9,20.7z M4.2,21l7.1,11.1c0,0-0.1-1.9-0.1-3.6l0,0V21H15v16.6h-4L3.7,26.3c0,0,0.1,2,0.1,3.7v7.5H0V21H4.2zM42.9,21c1.8,0,3.3,0.4,4.4,1.2c1.1,0.8,1.8,2.1,1.8,3.8c0,3.1-2,4.4-3.2,4.8l0,0l4.2,6.8h-4.5L42,31.2h-1.2v6.3h-3.9V21H42.9zM68.4,21v6l5.1-6h4.6l-5.8,6.6l6.2,10h-4.7l-4.2-6.9l-1.3,1.5v5.4h-3.9V21H68.4z M90.7,21v3.1h-6.9v3.4h6.5v3.1h-6.5v3.8h7.1v3.1H80V21H90.7z M25.9,24c-2.8,0-4.8,2-4.8,5.2s2.1,5.2,4.8,5.2s4.8-2,4.8-5.2C30.8,26.1,28.7,24,25.9,24z M42.3,24h-1.5v4.2h1.5c0.9,0,1.5-0.1,2-0.5c0.5-0.4,0.8-0.8,0.8-1.7c0-0.8-0.3-1.3-0.8-1.7C43.8,24.1,43.2,24,42.3,24L42.3,24z M5.6,0c2.9,0,5,0.8,6.4,2c1.4,1.2,2.7,3.1,2.7,6.3s-1.3,5.1-2.7,6.3c-1.4,1.2-3.5,2-6.4,2l0,0H0V0H5.6z M27.6,0v3.1h-6.9v3.4h6.5v3.1h-6.5v3.8h7.1v3.1H16.9V0H27.6z M41.2,0v3.1H37v13.5h-3.9V3.1h-4.3V0H41.2z M5.8,3.2h-2v10.1h2c1.6,0,2.8-0.5,3.5-1.2c0.7-0.6,1.5-1.8,1.5-3.8S10,5.1,9.3,4.4C8.6,3.7,7.4,3.2,5.8,3.2L5.8,3.2z"
              />
            </g>
          </g>
        </svg>
      </span>
    </span>
  );
}

export default Logo;
